<template>
  <div class="row justify-content-center">
    <div class="col-12 text-center position-R">
      <img src="/assets/images/placeHolder.jpeg" class="default-Img" alt="">
    </div>
  </div>
</template>
<script>
export default {
  name: "placeHolder",
}
</script>